import Vue from 'vue'
import state from '@/store/state'
import { url as postUrl, down as downUrl, massUploadUrl as massUploadUrl} from '../back-end'

// post
export const xPost = (requestClass, requestFunction, params = {}) => {
  const user = state.user ?? {"user":null}
  return Vue.axios({
    method: 'post',
    url: postUrl + '/' + requestClass + '/' + requestFunction,
    data: {
      params: JSON.stringify({
        params
      }),
      userPayload: JSON.stringify({
        user
      })
    },
    transformRequest: [data => {
      // Do whatever you want to transform the data
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// post
export const downPost = (requestClass, requestFunction, params = {}) => {
  const user = state.user ?? {"user":null}
  return Vue.axios({
    method: 'post',
    url: downUrl + '/' + requestClass + '/' + requestFunction,
    data: {
      params: JSON.stringify({
        params
      }),
      userPayload: JSON.stringify({
        user
      })
    },
    responseType: 'arraybuffer',
    transformRequest: [data => {
      // Do whatever you want to transform the data
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// massUpload Upload
export const xUploadMassupload = (requestClass, requestFunction, formData) => {
  const url = massUploadUrl + '/' + requestClass + '/' + requestFunction
  const user = state.user ?? {"user":null}
  formData.append('userPayload', JSON.stringify({
    user
  }))
  return Vue.axios.post(url,
    formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }
  )
}

// Massupload post
export const xPostMassupload = (requestClass, requestFunction, params = {}) => {
  const user = state.user ?? {"user":null}
  return Vue.axios({
    method: 'post',
    url: massUploadUrl + '/' + requestClass + '/' + requestFunction,
    data: {
      params: JSON.stringify({
        params
      }),
      userPayload: JSON.stringify({
        user
      })
    },
    transformRequest: [data => {
      // Do whatever you want to transform the data
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}